import { createFormAction } from 'redux-form-saga'

const getAllLeadsAction = createFormAction('GET_ALL_LEADS')

export { getAllLeadsAction }
